module.exports = __webpack_public_path__ + "img/20210806_103844.14492600.jpg";